<template>
  <el-dialog
    v-if="visible"
    :title="title"
    visible
    show-close
    top="5vh"
    width="90%"
    append-to-body
    :close-on-click-modal="false"
    :before-close="() => close()"
    v-el-dialog-drag
  >
    <Main
      ref="main"
      :platformCode="platformCode"
      @checkbox-change="(data) => (checkedRows = data)"
    />
    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-badge
        class="ml-2"
        :value="checkedRowCount"
        :hidden="!checkedRowCount"
      >
        <el-button
          type="primary"
          size="small"
          @click="confirm()"
          :disabled="!checkedRowCount"
        >
          {{ $l('INDEX.btn_confirm') || '确认' }}
        </el-button>
      </el-badge>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    platformCode: { type: String, default: '' },
  },
  data() {
    return { checkedRows: [] }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    close() {
      this.$refs.main.clearCheckboxRow()
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    confirm() {
      if (!this.checkedRowCount) return
      this.$emit('confirm', this.checkedRows)
      this.close()
    },
  },
}
</script>
